import React, {useCallback} from 'react';

import {copy} from 'src/utils/copyToClipboard';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import Group from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';

import {copierField} from './copier-field.module.styl';

type Props = {
    textToCopy: string,
};

export const CopierField = ({textToCopy}: Props) => {
    const onClick = useCallback(() => {
        copy(textToCopy);
    }, [textToCopy]);

    return (
        <Group className={copierField} gap="l" justify="space-between">
            <EllipsisTextHint>{textToCopy}</EllipsisTextHint>
            <BasicIconButton iconProps={{type: Icons.COPY}} onClick={onClick}/>
        </Group>
    );
};
